//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryTerms', {
//        templateUrl: 'views/components/views/deliveryTerms/deliveryTerms.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'deliveryTermsService', function (stateService, deliveryTermsService) {
//            const vm = this;
            
//            vm.model = {
//                itemsListTerms: []
//            };

//            async function loadDeliveryTerms() {
//                vm.model.itemsListTerms = (await deliveryTermsService.listDeliveryTerms());
//            }
            
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'deliveryterm':
//                        go({ deliveryterm_no: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };
            
//            vm.$onInit = function () {
//                loadDeliveryTerms();
//            };
//        }]
//    });
//})();
